var url = "b04806f4ba53f4fb7bbfe2dec9ea0aa8.svg";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;